import "./index.css";

const MainPageSection = ({ children }) => {
  return <section className="main-page-section">{children}</section>;
};

export default MainPageSection;
